import { useState, memo, useEffect } from "react";

import useGetApplicationsByJob from "@api/job/useGetApplicationsByJob";
import { Sort as SortIcon } from "@mui/icons-material";
import {
  Stack,
  Box,
  Skeleton,
  Typography,
  Button,
  IconButton,
  Popover,
  MenuItem,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "@app/hooks";

import { applicationActions } from "@features/application/slice";

import ApplicationItem from "./ApplicationItem";

const statusFilter = [
  { label: "New", value: "" },
  { label: "Saved", value: "saved" },
  { label: "Archived", value: "archived" },
];
const orderByFilter = [
  { label: "Date", value: "createdAt" },
  { label: "Price", value: "expectBudget" },
];

const PanelList = ({ jobId }: { jobId?: string }) => {
  const [anchorSort, setAnchorSort] = useState<HTMLButtonElement | null>(null);
  const { filters } = useAppSelector((state) => state.application);
  const dispatch = useAppDispatch();
  const { isLoading, data: apps } = useGetApplicationsByJob(jobId, filters);

  // const renderCount = useRef(0);
  // console.log('app list', { jobId, isLoading, apps });

  const [_, sort] = (filters.order ?? "").split(",");
  useEffect(() => {
    if (apps?.length && !isLoading) {
      dispatch(applicationActions.setApplicationIds(apps.map((item) => item.id)));
    }
  }, [apps]);

  return (
    <Stack rowGap={1} sx={{ overflowX: "auto", height: "100%" }}>
      <Box
        display="flex"
        flexDirection={"row"}
        px={2}
        py={1}
        alignItems="center"
        columnGap={1}
        height={40}
      >
        {statusFilter?.map((s, i) => (
          <Button
            key={i}
            variant="outlined"
            sx={{
              height: 24,
              borderRadius: "16px",
              color:
                filters?.type === s.value ? "common.partyTime" : "common.featherSoftBlue",
              borderColor:
                filters?.type === s.value ? "common.partyTime" : "common.featherSoftBlue",
              fontSize: 14,
              fontWeight: 500,
              textTransform: "none",
              p: 1,
            }}
            onClick={() => dispatch(applicationActions.setFilter({ type: s.value }))}
          >
            {s.label}
          </Button>
        ))}
        <Box>
          <IconButton onClick={(e) => setAnchorSort(e.currentTarget)}>
            <SortIcon sx={{ color: "common.featherSoftBlue" }} />
          </IconButton>
          <Popover
            open={!!anchorSort}
            anchorEl={anchorSort}
            onClose={() => setAnchorSort(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{ ".MuiPopover-paper": { p: 1 } }}
          >
            {orderByFilter?.map((opt, i) => (
              <MenuItem
                key={i}
                sx={{ bgcolor: opt.value === filters.order && "common.deutziaWhite" }}
                onClick={() => {
                  const toggleSort = sort === "asc" ? "desc" : "asc";
                  dispatch(
                    applicationActions.setFilter({
                      order: `${opt.value},${toggleSort}`,
                    })
                  );
                  setAnchorSort(null);
                }}
              >
                <Typography width={80} textAlign={"right"}>
                  {opt.label}
                </Typography>
              </MenuItem>
            ))}
          </Popover>
        </Box>
      </Box>
      <Box sx={{ overflowY: "auto" }}>
        {/* <p>renderCount: {(renderCount.current ++)}</p> */}
        {isLoading ? (
          <Skeleton width="100%" height={65} />
        ) : apps?.length ? (
          // [1,2,3,4,5,6,67,7,8,8,6,7,8,9,0,8,6,4,3,35,6,7,6].map((app, i) => (
          apps.map((app, i) => <ApplicationItem key={i} app={app} jobId={jobId} />)
        ) : (
          <Box>
            {/* <Divider /> */}
            <Typography fontSize={12} pt={1} sx={{ textAlign: "center" }}>
              No applications found.
            </Typography>
          </Box>
        )}
      </Box>
    </Stack>
  );
};

export default memo(PanelList);
